import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ArticleDetailComponent } from './article-detail.component';
import { SharedModule } from '@app/core/shared/shared.module';  // Import SharedModule to use PopUpComponent

const routes: Routes = [
  {
    path: '',
    component: ArticleDetailComponent,
  },
];

@NgModule({
  declarations: [
    ArticleDetailComponent,  // PopUpComponent removed since it's declared in SharedModule
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule  // Import SharedModule to access PopUpComponent
  ],
})
export class ArticleDetailModule {}
